import { render, staticRenderFns } from "./tagEdit.vue?vue&type=template&id=347feae0&"
import script from "./tagEdit.vue?vue&type=script&lang=js&"
export * from "./tagEdit.vue?vue&type=script&lang=js&"
import style0 from "./tagEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports